import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseList = {
  gap: css`var(--cse-list-gap, ${csSpacing.spacing05})`,
  rowGap: css`var(--cse-list-row-gap, ${csSpacing.spacing04})`,
  dividerColor: css`var(--cse-list-divider-color, ${csColorBorder.light})`,
  dividerGap: css`var(--cse-list-divider-gap, ${csSpacing.spacing06})`,
}

export const style: CSSResult = css`
  .cse-list {
    --cse-divider-border-color: ${cseList.dividerColor};

    display: flex;
    flex-direction: column;
    gap: ${cseList.gap};
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .cse-list.inline {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: ${cseList.gap};
    row-gap: ${cseList.rowGap};
  }

  .cse-list.has-divider {
    gap: ${cseList.dividerGap};
  }

  .cse-list.has-divider.inline {
    row-gap: ${cseList.rowGap};
  }
`
